import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class EngineerSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      autoWidth: true,
      pagination: false,
      arrows: false,
      type: 'loop',
      gap: `min(${9 / 16}rem, ${9 / 375 * 100}vw)`,
      rewind: true,
      loop: true,
      speed: 1200,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    this.slider.on('mounted move', () => {
      const end  = this.slider.Components.Controller.getEnd() + 1;
      const rate = Math.min( ( this.slider.index + 1 ) / end, 1 );
      this.dom.progress.style.width = String( 100 * rate ) + '%';
    } );
    this.slider.mount();
  }
}

export default EngineerSlides